__webpack_require__.p = "https://prod.na.safety-genie.whs.amazon.dev/";